import ApiService from './ApiService'

class AuthenticationService {
  static async logout () {
    try {
      await ApiService.POST('/api/users/logout')
    } catch (e) {

    }
    localStorage.clear()
  }

  static isConnected () {
    AuthenticationService.verifySession().then((connected) => {
      return connected
    }).catch(e => {
      console.log(e)
      localStorage.clear()
      return false
    })
  }

  static getUser () {
    const user = localStorage.getItem('user')
    if (user) {
      try {
        return JSON.parse(user)
      } catch (e) {
        localStorage.removeItem('user')
        return null
      }
    }
    return null
  }

  static getRoles () {
    const roles = localStorage.getItem('roles')
    if (roles) {
      return JSON.parse(roles)
    }
    return null
  }

  static setUser (user) {
    localStorage.setItem('user', JSON.stringify(user))
  }

  static setRoles (roles) {
    localStorage.setItem('roles', JSON.stringify(roles))
  }

  static async verifySession () {
    return ApiService.GET('/api/users/profile')
  }

  static async login (code, password) {
    return ApiService.POST('/api/login', { code, password })
  }

  static async clientLogin (uuid) {
    return ApiService.POST(`/api/clients/login/${uuid}`)
  }
}

export default AuthenticationService
